/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workflowsGet } from "../../funcs/workflowsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$inboundSchema,
};

export const tool$workflowsGet: ToolDefinition<typeof args> = {
  name: "workflows_get",
  description: `Get workflow details

Retrieves details of a specific workflow`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workflowsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
